/*
 * shopit-api
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: v1
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 *
 * Swagger Codegen version: 3.0.41
 *
 * Do not edit the class manually.
 *
 */
import {ApiClient} from '../ApiClient';

/**
 * The OrdersIndexPagination model module.
 * @module model/OrdersIndexPagination
 * @version v1
 */
export class OrdersIndexPagination {
  /**
   * Constructs a new <code>OrdersIndexPagination</code>.
   * @alias module:model/OrdersIndexPagination
   * @class
   * @param next_page {Number} 
   */
  constructor(next_page) {
    this.next_page = next_page;
  }

  /**
   * Constructs a <code>OrdersIndexPagination</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:model/OrdersIndexPagination} obj Optional instance to populate.
   * @return {module:model/OrdersIndexPagination} The populated <code>OrdersIndexPagination</code> instance.
   */
  static constructFromObject(data, obj) {
    if (data) {
      obj = obj || new OrdersIndexPagination();
      if (data.hasOwnProperty('next_page'))
        obj.next_page = ApiClient.convertToType(data['next_page'], 'Number');
    }
    return obj;
  }
}

/**
 * @member {Number} next_page
 */
OrdersIndexPagination.prototype.next_page = undefined;

